<template>
  <div>
    <base-header class="pb-6">
      <b-row align-v="center" class="py-4">
        <b-col cols="7" lg="6">
          <h6 class="h2 text-white d-inline-block mb-0">Agent Production</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--6">
      <upgrade-overlay :title="'Production Report'" :upgradeImg="'dashboard.png'" :placeholderImg="'placeholders/agent-production.png'" v-if="!subPro"></upgrade-overlay>
      <div v-else>
        <production-report :userRoute="userRoute"></production-report>
      </div>
      <upgrade-overlay :title="'Agent Production'" :upgradeImg="'dashboard.png'" :placeholderImg="'placeholders/agent-production.png'" v-if="!subBusiness"></upgrade-overlay>
      <div v-else>
        <agent-production :userRoute="userRoute" v-if="role == 'owner'"></agent-production>
      </div>
    </b-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import {Select, Option} from 'element-ui'
import AgentProduction from '@/views/Components/Reports/AgentProduction';
import ProductionReport from '@/views/Components/Reports/ProductionReport';
import UpgradeOverlay from '@/views/Components/Overlays/UpgradeOverlay';

export default {
  components: {
    RouteBreadCrumb,
    [Select.name]: Select,
    [Option.name]: Option,
    AgentProduction,
    ProductionReport,
    UpgradeOverlay,
  },
  computed: {
    ...mapGetters({
      userRoute: 'profile/userRoute',
      subBasic: 'profile/subBasic',
      subStandard: 'profile/subStandard',
      subPremium: 'profile/subPremium'
    }),
    subPro() {
      return this.subBasic || this.subStandard;
    },
    subBusiness() {
      return this.subStandard;
    },
    role() {
      return this.$store.getters['roles/roles'][0];
    }
  },
  mounted() {
    document.title = "Agent Production Reports | ClarityNOW";
  }
};
</script>